import {
  CHAMBER_SET_LOWER_CAP_ACCESORY,
  CHAMBER_SET_UPPER_CAP_ACCESORY, CHAMBERS_MANIFOLD_MAIN_ROW_CLEAN, CHAMBERS_MANIFOLD_VOID_CLEAN,
  CHAMBERS_META_CLEAN,
  CLOSE_MANIFOLD_ENTRY,
  CLOSE_MANIFOLD_REMOVAL_PROMPT_DIALOG,
  MANIFOLD_ENTRY_CHECK_FOR_OVERLAP,
  MANIFOLD_ENTRY_MOVED,
  MANIFOLD_ENTRY_REMOVE_OVERLAPPING,
  MANIFOLD_ENTRY_SHOW_OVERLAP_DIALOG,
  REMOVE_MANIFOLD_MAIN,
  SET_CURRENT_MANIFOLD_ENTRY, SET_OP_STRUCTURE_COLLISION_PRESENT,
  SET_OVERLAP_PRESENT,
  SET_STRUCTURE_COLLISION_PRESENT,
  SHOW_MANIFOLD_ENTRY,
  MANIFOLD_ENTRY_MANIFOLD_CHAMBER_SHOW_EDIT_OR_REMOVE_PROMPT, FLOATING_TOOL_TEE_CLOSE
} from "../lib/types";

export const manifoldEntryMoved = ( x, y ) => dispatch => {
  dispatch({
    type: MANIFOLD_ENTRY_MOVED,
    payload: {
      x,
      y
    }
  });
};

export const showManifoldEntryDialog = ( manifoldId, accessory, promptForRemoval ) => dispatch => {
  dispatch({
    type: SHOW_MANIFOLD_ENTRY,
    payload: {
      accessory: { ...accessory },
      manifoldId: manifoldId,
      promptForRemoval
    }
  });
  dispatch({
    type: FLOATING_TOOL_TEE_CLOSE
  });
};

export const setCurrentManifold = ( currentManifold ) => dispatch => {
  dispatch({
    type: SET_CURRENT_MANIFOLD_ENTRY,
    payload: {
      currentManifold: currentManifold
    }
  });
};

export const closeManifoldEntryDialog = () => dispatch => {
  dispatch({
    type: CLOSE_MANIFOLD_ENTRY
  });
};

export const setCheckForOverlap = ( checkForOverlap ) => dispatch => {
  dispatch({
    type: MANIFOLD_ENTRY_CHECK_FOR_OVERLAP,
    payload: checkForOverlap
  });
};

export const setOverlapPresent = ( setOverlapPresent ) => dispatch => {
  dispatch({
    type: SET_OVERLAP_PRESENT,
    payload: setOverlapPresent
  });
};

export const setStructureCollisionDetected = ( value ) => dispatch => {
  dispatch({
    type: SET_STRUCTURE_COLLISION_PRESENT,
    payload: value
  });
};
export const setOppositeStructureCollisionDetected = ( detected, manifoldsIds ) => dispatch => {
  dispatch({
    type: SET_OP_STRUCTURE_COLLISION_PRESENT,
    payload: { detected, manifoldsIds }
  });
};

export const toggleOverlapDialog = ( showOverlapDialog, existingManifold, overlappingManifold ) => dispatch => {
  dispatch({
    type: MANIFOLD_ENTRY_SHOW_OVERLAP_DIALOG,
    payload: {
      showOverlapDialog,
      overlappedManifold: existingManifold,
      overlappingManifold: overlappingManifold
    }
  });
};

export const removeManifold = ( manifold ) => dispatch => {

  dispatch({
    type: CHAMBERS_META_CLEAN,
    payload: {
      manifoldId: manifold.id,
      actualRow: manifold.letRow,
      actualCol: manifold.letColumn
    }
  });

  dispatch({
    type: CHAMBERS_MANIFOLD_VOID_CLEAN,
    payload: {
      manifoldId: manifold.id,
      actualRow: manifold.letRow,
      actualCol: manifold.letColumn
    }
  });

  dispatch({
    type: CHAMBERS_MANIFOLD_MAIN_ROW_CLEAN,
    payload: {
      manifoldId: manifold.id,
      actualRow: manifold.letRow,
      actualCol: manifold.letColumn
    }
  });

  dispatch({
    type: manifold.isUpper ? CHAMBER_SET_UPPER_CAP_ACCESORY : CHAMBER_SET_LOWER_CAP_ACCESORY,
    payload: {
      accessory: null,
      row: manifold.letRow,
      col: manifold.letColumn
    }
  });


  dispatch({
    type: REMOVE_MANIFOLD_MAIN,
    payload: {
      manifoldId: manifold.id,
      actualRow: manifold.letRow,
      actualCol: manifold.letColumn
    }
  });

  dispatch({
    type: SET_OVERLAP_PRESENT,
    payload: false
  });
};

export const removeOverlappingManifold = () => dispatch => {
  dispatch({
    type: MANIFOLD_ENTRY_REMOVE_OVERLAPPING
  });
};

export const closeRemovalPromptDialog = () => dispatch => {
  dispatch({
    type: CLOSE_MANIFOLD_REMOVAL_PROMPT_DIALOG
  });
};

export const showManifoldChamberEditOrRemove = ( show, row, col, manifoldId, accessory ) => dispatch => {
  dispatch({
    type: MANIFOLD_ENTRY_MANIFOLD_CHAMBER_SHOW_EDIT_OR_REMOVE_PROMPT,
    payload: {
      show,
      row,
      col,
      manifoldId,
      accessory
    }
  });
};



// WEBPACK FOOTER //
// ./src/actions/manifold-entry-actions.js